import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import appConfig from '../../../config';

import UserProfile from '../../components/patient/UserProfile';
import MenuLinks from '../../components/patient/MenuLinks';
import PatientInfo from '../../components/patient/PatientInfo';
import DentalHistory from '../../components/patient/Dental_history/DentalHistory';
import MedicalHistory from '../../components/patient/Medical_history/MedicalHistory';
import TreatmentRecord from '../../components/patient/Treatment_record/TreatmentRecord';
import Gallery from '../../components/patient/Gallery/Index';
import Prescription from '../../components/patient/Prescription/Index';

import TreatmentPlan from '../../components/patient/Treatment_plan/TreatmentPlan';
import ChartingPage from '../../containers/Charting';

import {
    getBranchesApi
} from '../../actions/branches';

import {
    getPractitionersApi
} from '../../actions/practitioners';

let App = window.App;

class PatientEdit extends Component {
    static propTypes = {
        getBranchesApi: PropTypes.func.isRequired,
        getPractitionersApi: PropTypes.func.isRequired,
        session: PropTypes.object.isRequired,
        branches: PropTypes.object.isRequired,
        practitioners: PropTypes.object.isRequired
    };

    state = {
        menu : [
            {
                link: '#infoContentPage',
                label: 'Personal Info',
                permissions: ['patients.*', 'patients.view']
            },
            {
                link: '#dentalHistoryPage',
                label: 'Dental History',
                permissions: ['dental-history.*', 'dental-history.view']
            },
            {
                link: '#medicalHistoryPage',
                label: 'Medical History',
                permissions: ['medical-history.*', 'medical-history.view']
            },
            {
                link: '#treatmentPlanPage',
                label: 'Treatment Plan',
                permissions: ['treatment-plan.*', 'treatment-plan.view']
            },
            {
                link: '#chartingPage',
                label: 'Charting',
                permissions: ['charting.*', 'charting.view']
            },
            {
                link: '#treatmentPage',
                label: 'Treatment Records',
                permissions: ['treatment-record.*', 'treatment-record.view']
            },
            {
                link: '#galleryPage',
                label: 'Gallery',
                permissions: ['gallery.*', 'gallery.view']
            },
            {
                link: '#prescriptionPage',
                label: 'Prescription',
                permissions: ['prescription.*', 'prescription.view']
            }
        ],
        data: null,
        refreshToTreatment : false,
        permissions: []
    };

    getPatient = () => {
        const url = appConfig.apiUrl + 'dental/patients/' + this.props.params.patientId;
        // console.log(this.props.params.patientId);

        axios({
            url: url,
            method: 'get',
            responseType: 'json',
        }).then((response) => {
            let user = response.data.data;
            // console.log(user);
            this.setState({data: user});
        }).catch(function (error) {
            App.blockUI({message : 'data fetching interrupted... Please reload the page',boxed : true});
        });
    };

    handleUpdatePatientInfo = () => {
        this.getPatient();
    };

    handleSavePatientInfo = (e) => {
        let patientId = this.props.params.patientId;

        if (! this.props.params.patientId) {
            return false;
        }

        let url = appConfig.apiUrl + 'dental/patients/' + patientId + '/update-picture';

        axios.put(url, { media_id: document.getElementById('media_id').value}).then((response) => {
            let user = response.data.data;

            this.setState({data: user});

            this.props.showNotification('success', 'Updated photo');

        }).catch((error)=> {
            this.props.showNotification('error', 'Failed in updating photo');
        });
    };

    componentWillMount() {
        this.getPatient();
    }

    render() {
        const { session } = this.props;
        let params = this.props.params; // from router

        let user = session.get('user').toJS();
        let permissions = user.permissions;

        return (
            <div className="page-content patientEditContent">
                <div className="row">
                    <div className="col-md-12" style={{minHeight : '168px'}}>
                        <UserProfile data={this.state.data} stateView="patientEdit" onMediaChoice={this.handleSavePatientInfo} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="profile-content">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="portlet light">
                                        <div className="portlet-title tabbable-line">
                                            <ul className="nav nav-tabs nav-justified" id="menuTabsLinks">
                                                {this.state.menu.map((item, i) => {
                                                    return <MenuLinks userpermissions={permissions} {...item} key={i} index={i} />
                                                })}
                                            </ul>
                                        </div>
                                        <div className="portlet-body">
                                            <div className="tab-content">

                                                <div className="tab-pane active" id="infoContentPage">

                                                    <PatientInfo permissions={permissions}
                                                                 storeParams={params}
                                                                 onUpdatePatientInfo={this.handleUpdatePatientInfo}/>

                                                </div>

                                                <div className="tab-pane" id="dentalHistoryPage">

                                                    <DentalHistory permissions={permissions} storeParams={params} />

                                                </div>
                                                <div className="tab-pane" id="medicalHistoryPage">
                                                    <MedicalHistory permissions={permissions} storeParams={params} />
                                                </div>

                                                <div className="tab-pane" id="chartingPage">
                                                    <ChartingPage permissions={permissions}
                                                                  patientId={this.props.params.patientId} {...this.props}
                                                                  refreshToTreatment={(e) => {this.setState({refreshToTreatment: true})}}
                                                                  offToTreatment={(e) => {this.setState({refreshToTreatment: false})}}/>
                                                </div>

                                                <div className="tab-pane" id="treatmentPlanPage">
                                                    <TreatmentPlan permissions={permissions}
                                                                   storeParams={params} />
                                                </div>

                                                <div className="tab-pane" id="treatmentPage">
                                                    <TreatmentRecord permissions={permissions}
                                                                     user={this.props.user}
                                                                     branches={this.props.branches}
                                                                     practitioners={this.props.practitioners}
                                                                     getBranchesApi={this.props.getBranchesApi}
                                                                     getPractitionersApi={this.props.getPractitionersApi}
                                                                     storeParams={params}
                                                                     refreshFromCharting={this.state.refreshToTreatment} />
                                                </div>

                                                <div className="tab-pane" id="galleryPage">
                                                    <Gallery permissions={permissions} patientId={this.props.params.patientId} {...this.props} />
                                                </div>

                                                <div className="tab-pane" id="prescriptionPage">
                                                    <Prescription permissions={permissions} patientId={this.props.params.patientId} {...this.props} />
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    session: state.session,
    branches: state.branches,
    practitioners: state.practitioners
});

export default connect(mapStateToProps, {
    getBranchesApi,
    getPractitionersApi
})(PatientEdit);


/** WEBPACK FOOTER **
 ** ./src/containers/PatientEdit/index.js
 **/